// Using Vue for the product quantities
// Get the divisible property, from the Tag
let price = document.getElementById('currentPrice').innerHTML;

var elements2 = document.querySelectorAll('.privacy-panel-hardware');
var hardwareProducts = [];
elements2.forEach(function(item) {
  hardwareProducts.push({
    id: item.dataset['id'],
    type: item.dataset['type'], // type: ['post', 'brackets']
    price: item.dataset['price']
  })
})

new Vue({ 
  el: '#PRIVACYquantities',
  data: function () {
    return {
      panelTotals: 0,
      panelQty: 0,
      addOnsQty: {},
    }
  },
  computed: {
    totalPrice() {
      var addOnPrices = 0;
      var self = this;
      var panelPrice = this.panelQty * price;
      hardwareProducts.forEach(function(product) {
        var qty = self.addOnsQty[product.id] ? self.addOnsQty[product.id] : 0;
        var addOnPrice = product.price * qty;
        addOnPrices += addOnPrice;
      })
      var sum = panelPrice + addOnPrices;
      return sum.toFixed(2);
    },
  },
  methods: {
    updateAddOnsQty() {
      hardwareProducts.forEach((product) => {
        if (product.type === 'post') {
          this.addOnsQty[product.id] = Number(this.panelQty )+ 1;
        } else {
          this.addOnsQty[product.id] = Number(this.panelQty);
        }
      });
    },
    // PANEL QTY change
    onPANELChange(event) {
      this.panelQty = event.target.value;
      this.updateAddOnsQty();
    },
    // Hardwares QTY change
    plusQty(variant_id) {
      if (this.addOnsQty[variant_id]) {
        this.addOnsQty[variant_id]++;
      } else {
        this.addOnsQty[variant_id] = 1;
      }
      this.addOnsQty = { ...this.addOnsQty }
    },
    // Hardwares QTY change
    minusQty(variant_id) {
      if (this.addOnsQty[variant_id] || this.addOnsQty[variant_id] > 1) {
        this.addOnsQty[variant_id]--;
      } else {
        this.addOnsQty[variant_id] = 0;
      }
      this.addOnsQty = { ...this.addOnsQty }
    },
  }
})


